<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    机场<br>
<a href="http://www.szairport.com/">深圳宝安国际机场</a><br>
<br>
安检须知<br>
<br>

一、二维码电子登机牌<br>
2017年9月28日起，深圳机场正式启用二维码电子登机牌过检登机服务，由深圳机场乘坐国内航班且无托运行李的旅客，通过相关渠道办理二维码电子登机牌后，凭个人有效身份证件及二维码电子登机牌即可直接办理安检和登机手续，享受从值机、安检到登机的顺畅出行体验。<br>
<br>
据了解，相比传统值机方式，此次新推出的二维码电子登机牌过检登机服务省去了打印纸质登机牌的环节。对无托运行李的商务旅客，此举将进一步提高出行效率，提升乘机的顺畅体验。乘坐深圳始发的国内出港航班且无托运行李的旅客，可使用手机通过航旅纵横App、各航空公司网上值机等渠道（需支持生成电子登机牌）提前办理值机并获取二维码电子登机牌。到达机场后，凭个人有效身份证件和二维码电子登机牌，可直接前往国内安检区进行安检验证。登机前，旅客需出示二维码电子登机牌，由工作人员扫描并打印登机凭条给旅客作为登机凭证，并在登机时交由安全监护人员复查。<br>
<br>
机场方面特别提醒，目前深圳机场二维码电子登机牌过检登机服务仅支持乘坐深圳始发国内航班且无托运行李的普通旅客，有托运行李、中转联程航班、未满12岁儿童、携带婴儿及需要特殊服务的旅客建议提前两小时到机场相应柜台办理乘机和托运手续。<br>
<br>
（一）二维码电子登机牌过检登机流程<br>
1.手机办理乘机手续<br>
<br>
旅客通过航旅纵横、各航空公司网上值机等渠道（需支持生成电子登机牌）提前办理值机手续并获取二维码电子登机牌。<br>
<br>
2.安检信息验证<br>
<br>
旅客前往国内安检通道，在安检验证柜台出示个人有效身份证件及二维码电子登机牌，安检人员通过安检信息管理系统验证旅客信息，验证通过后，旅客按正常程序接受人身和随身行李安全检查。<br>
<br>
3.登机口扫描<br>
<br>
旅客登机时，在登机口出示二维码电子登机牌，工作人员扫描电子二维码并打印带有安检验讫标识的登机凭条给旅客作为登机凭证。<br>
<br>
4.登机前复查<br>
<br>
旅客在登机廊桥或远机位登机梯处，将登机凭条交由安全监护人员复查。<br>
<br>
（二）特别提示<br>
1.二维码电子登机牌过检登机服务目前仅支持深圳始发国内航班无托运行李的普通旅客，有托运行李、中转联程航班、未满12岁儿童、携带婴儿及需要特殊服务的旅客建议提前两小时到机场相应柜台办理乘机和托运手续。<br>
<br>
2.未经机场、航空公司或中航信授权的第三方平台发布的非国际航协（IATA）标准二维码电子登机牌，安检将不予放行。<br>
<br>
二、智能安检通道<br>
2019年11月深圳机场全新上线了“易安检”平台，安全信用较好的常旅客可通过该平台在线预约使用智能安检通道，享受更加高效、便捷的安检服务。作为民航局“旅客‘易安检’计划”首批试点单位，这也是深圳机场针对安检提质增效、旅客智慧化出行推出的又一重要举措。<br>
<br>
（一）智能安检通道流程<br>
1.第一道闸机位于国内候检区入口，共5组19台。<br>
（1）乘机旅客持身份证或护照在第一道闸机读取证件信息后，如果信息核实无误，即可获得乘机资格准入，并可提醒旅客托运行李是否需要开箱检查。<br>
<br>
2.第二道闸机 “易安检通道”位于19、20号通道前端，共1组4台。<br>
（1） 对安全信用较好的常旅客，入口闸机验证后会指引其经由第二道闸机进入“易安检通道”，旅客可以通过人像比对直接“刷脸”快速通过第二组闸机。<br>
<br>
（2）旅客通过“易安检”微信小程序进行个人信息认证和乘机安全知识测试，审核通过后即可完成注册。旅客乘机前仅需在“易安检”平台上填写预约使用智能安检通道的时间段，便可完成预约，预约适用于深圳机场始发的所有国内航班。预约成功后，“易安检”平台会向旅客推送预约成功提示信息和安检通道分布图。旅客在到达安检现场后，仅需通过身份证和人脸识别即可进入“易安检通道”，体验全流程自助安检服务。<br>
<br>
（二）特别提醒<br>
第一道闸机处，持其他证件或携带婴幼儿的旅客出示乘机凭证可从人工通道进入。<br>
<br>
三、国内安全检查功能通道分布<br>
深圳机场国内安全检查四层出发大厅，共有42条国内出发通道，功能性通道有10条，包括头等、公务舱安检通道，军人、消防救援安检通道，城市候机楼、应急安检通道，易安检通道（合资格人士），爱心通道（OPO优先）。<br>
<br>
（一）深圳机场国内安检区3-4号为“城市候机楼、应急安检通道”。<br>
城市候机楼旅客凭加盖好查讫章的“专用登机牌”的旅客或临近登机时间节点的旅客，可使用该通道接受安全检查。<br>
<br>
通道开放时间：05:10-20:00<br>
<br>
（二）深圳机场国内安检区19A-19B号安检通道为“头等、公务舱安检通道”“军人、消防救援人员安检通道”。
持有头等舱或公务舱乘机凭证的旅客以及军人、消防救援人员凭有效证件，可在深圳机场使用该通道接受乘机安检。<br><br>

通道开放时间：05：00-22：30<br>

（三）深圳机场国内安检区19C-20C号为“易安检通道（合资格人士）”。<br>
通道开放时间：05:00-21:00<br><br>

（四）深圳机场国内安检区37-38号为“爱心通道（OPO优先）”。<br>
老人、小孩、残疾人士等社会关爱人士可使用该通道接受安全检查，该通道的设置为老、弱、病、残旅客提供了便捷、体贴的乘机服务体验。<br>
<br>
通道开放时间：00:00-24:00<br>
<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        // {
        //   name: "",
        //   title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>
